var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuiltwithScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#098603"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#094303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092503"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.9838,42.744l.05557,15.36617.38902,1.58386c.47238,1.86173,1.13926,3.6123,1.88951,4.8905,2.3341,4.00132,6.36321,6.8078,11.22592,7.78034,2.16738.44459,5.5296.36123,7.72477-.19451,4.80714-1.25041,8.91961-4.55706,11.14256-8.97518,1.36156-2.72312,1.94509-6.44657,1.52828-9.69764-.69467-5.39066-4.05689-10.19781-8.91961-12.80978-2.38968-1.30599-4.64042-1.83394-7.8637-1.83394-1.22263,0-2.41746.05558-2.69533.08336l-.47238.08336v6.72444c0,3.69566.05557,6.69665.11115,6.66887,2.05623-1.02812,2.13959-1.0559,3.25107-1.00033.6391.02779,1.33377.19451,1.695.33345.91697.44459,1.80615,1.41714,2.16738,2.38968,1.2782,3.39001-1.19484,6.66887-4.80714,6.391-1.97287-.13893-3.25107-1.2782-3.89017-3.36222-.25008-.83361-.27787-2.05623-.30566-15.36617l-.05557-14.44921h-12.22625c0,.02778.05557,15.39396.05557,15.39396Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltwithScraper);
export default __webpack_public_path__ + "static/media/builtwith-scraper.febd8e81624a91dff4f56a9f31a9c675.svg";
export { ForwardRef as ReactComponent };